declare module "@mui/material/styles" {
  interface Palette {
    readonly black: Palette["primary"];
    readonly boxShadow: Palette["primary"];
    readonly border: Palette["primary"];
    readonly blue: Palette["primary"];
    readonly danger: Palette["primary"];
    readonly gray: Palette["primary"];
    readonly rose: Palette["primary"];
    readonly surface: Palette["primary"];
    readonly yellow: Palette["primary"];
    readonly disabled: Palette["primary"];
    readonly missed: Palette["primary"];
  }
  interface PaletteOptions {
    black: PaletteOptions["primary"];
    boxShadow: Palette["primary"];
    border: PaletteOptions["primary"];
    blue: PaletteOptions["primary"];
    danger: PaletteOptions["primary"];
    gray: PaletteOptions["primary"];
    rose: PaletteOptions["primary"];
    surface: PaletteOptions["primary"];
    yellow: PaletteOptions["primary"];
    disabled: PaletteOptions["primary"];
    missed: PaletteOptions["primary"];
  }
}

export const palette = {
  border: {
    main: "#cacdde",
  },
  boxShadow: {
    light: "#0000001F",
    main: "#00000024",
    dark: "#00000033",
    contrastText: "#ffffff",
  },
  black: {
    light: "#666666",
    main: "#474747",
    dark: "#000000",
    contrastText: "#ffffff",
  },
  blue: {
    light: "#5fb4fa",
    main: "#1185C7",
    dark: "#005996",
    contrastText: "#ffffff",
  },
  danger: {
    main: "#DD3333",
    light: "#f1ded8",
  },
  gray: {
    light: "#ffffff",
    main: "#e0e0e0",
    dark: "#9E9E9E",
    contrastText: "#DADADA",
  },
  primary: {
    light: "#8988C1",
    main: "#5A5B90",
    dark: "#4A497B",
  },
  rose: {
    light: "#f26a98",
    main: "#BC376A",
    dark: "#870040",
  },
  secondary: {
    light: "#DD7866",
    main: "#E4541E",
    dark: "#B93A13",
  },
  surface: {
    light: "#ffffff",
    main: "#F3F5F9",
    dark: "#c0c2c6",
  },
  success: {
    light: "#6abf95",
    main: "#398E67",
    dark: "#00603c",
  },
  yellow: {
    light: "#FBED63",
    main: "#FBD576",
    dark: "#FABE28",
    contrastText: "#000000",
  },
  paused: {
    main: "#9E9E9E",
    light: "#BDBDBD",
    dark: "#757575",
    contrastText: "#ffffff",
  },
  missed: {
    light: "#e69d90",
    main: "#DD7866",
    dark: "#d4533c",
    contrastText: "#ffffff",
  },
  disabled: {
    light: "rgba(0, 0, 0, 0.26)",
    main: "#0000008a",
  },
};
